// title.service.ts

import { Injectable } from '@angular/core';
import { titles } from './titles';

@Injectable({
  providedIn: 'root'
})
export class TitleService {
  getTitles(): string[] {
    return titles;
  }
}
